<template>
  <div v-if="isShow" class="cropperBox">
    <div class="cropper">
      <div class="top">
        <div class="imgBox">
          <img ref="imgs">
        </div>
        <div class="previewBox">
          <div class="title">预览</div>
          <div ref="preview" class="preview"></div>
          <!-- <div class="aspectRatio">
            <el-select v-model="aspectRatio" placeholder="请选择裁剪比例">
              <el-option label="1/1" value=1 />
              <el-option label="1.5/1" value=1.5 />
              <el-option label="1.6/1" value=1.6 />
              <el-option label="1.7/1" value=1.7 />
              <el-option label="1.8/1" value=1.8 />
              <el-option label="1.9/1" value=1.9 />
              <el-option label="2/1" value=2 />
            </el-select>
          </div> -->
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <div class="button-group">
            <button @click="change('left')"><span>向左旋转</span></button>
            <button @click="change('right')"><span>向右旋转</span></button>
            <button @click="change('big')"><span>放大</span></button>
            <button @click="change('small')"><span>缩小</span></button>
            <button @click="change('reset')"><span>重置</span></button>
          </div>
        </div>
        <div class="right">
          <div class="button-group">
            <button class="primary large" @click="sure"><span>确定</span></button>
            <button class="primary large" @click="cancel"><span>取消</span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import 'cropperjs/dist/cropper.css'
import Cropperjs from 'cropperjs'

export default {
  data() {
    return {
      isShow: false,
      cropper: null,
      options: null,
      aspectRatio:null,
    }
  },
  methods: {
    show(options) {
      this.isShow = true
      this.$nextTick(function() {
        this.options = options
        this.newInit()
      })
    },
    hidden() {
      const _ = this
      _.cropper.destroy()
      _.cropper = null
      _.isShow = false
    },
    change(type) {
      const cropper = this.cropper
      switch (type) {
        case 'left':
          cropper.rotate(-90)
          break
        case 'right':
          cropper.rotate(90)
          break
        case 'big':
          cropper.zoom(0.1)
          break
        case 'small':
          cropper.zoom(-0.1)
          break
        case 'reset':
          cropper.reset()
          break
      }
    },
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        url = window.createObjectURL(file)
      } else if (window.URL !== undefined) {
        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        url = window.webkitURL.createObjectURL(file)
      }
      return url
    },
    newInit() {
      const _ = this
      const imgs = _.$refs.imgs
      const file = _.options.file
      imgs.src = _.getObjectURL(file)
      _.cropper = new Cropperjs(imgs, {
        preview: _.$refs.preview,
        aspectRatio:this.aspectRatio || _.options.aspectRatio || 1,
        cropBoxMovable:true,
        autoCropArea:0.5,
        dragMode: 'move',
        viewMode: 1
      })
    },
    sure() {
      const _ = this
      _.cropper.getCroppedCanvas({
        maxWidth: _.options.aspectRatio * 1000,
        maxHeight: 1000
      }).toBlob(blob => {
        const file = new File([blob], Date.now() + '.' + blob.type.split('/')[1], {
          type: blob.type
        })
        _.hidden()
        _.options.success(file)
      })
    },
    cancel() {
      this.options.cancel()
      this.hidden()
    }
  }
}
</script>
<style lang='scss' scoped>
.cropperBox{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  .cropper{
    width: 800px;
    height: 600px;
    padding: 0 10px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    box-sizing: content-box;
    border-radius: 5px;
    &>div{
      width: 100%;
    }
    .top{
      height: 80%;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      &>*{
        height: 100%;
      }
      .imgBox{
        width: 70%;
        background-color: #bbb;
        img{
          max-width: 100%;
        }
      }
      .previewBox{
        width: 28%;
        .title{
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 18px;
        }
        .preview{
          width: 100%;
          height: calc(100% - 40px);
          overflow: hidden;
          border: 1px solid #ccc;
        }
        .aspectRatio{
          width:100%;
          height: calc(100% - 200px);
        }
      }
    }
    .bottom{
      height: 10%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &>*{
        text-align: center;
      }
      .left{
        flex: 5;
        margin-right: 20px;
      }
      .right{
        flex: 2;
      }
    }
  }
}
.button-group{
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  button{
    display: inline-block;
    position: relative;
    margin-bottom: 0;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    line-height: 1.5;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    height: 32px;
    padding: 0 15px;
    font-size: 14px;
    border-radius: 4px;
    transition: color .2s linear,background-color .2s linear,border .2s linear,box-shadow .2s linear;
    color: #515a6e;
    background-color: #fff;
    border-color: #dcdee2;
    margin-left: 0;
    &.large{
      height: 40px;
      padding: 0 15px;
      font-size: 16px;
      border-radius: 4px;
    }
    &.primary{
      color: #fff;
      background-color: #2d8cf0;
      border-color: #2d8cf0;
      &:first-child:not(:last-child){
        border-right-color: #2b85e4;
      }
      &:last-child:not(:first-child){
        border-left-color: #2b85e4;
      }
      &:hover{
        color: #fff;
        background-color: #57a3f3;
        border-color: #57a3f3;
      }
    }
    &:not(:first-child){
      margin-left: -1px;
    }
    &:first-child:not(:last-child){
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
    }
    &:last-child:not(:first-child){
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }
    &:not(:first-child):not(:last-child){
      border-radius: 0;
    }
    &:hover{
      color: #57a3f3;
      background-color: #fff;
      border-color: #57a3f3;
      z-index: 2;
    }
  }
}
</style>
